import React, { lazy } from 'react';
import { Route } from 'react-router';
import Authenticated from '../../components/auth/Authenticated';
import routes from '../routes';

const DateNightListScreen = lazy(() => import('../../screens/DateNight/screens/List'));
const DateNightViewScreen = lazy(() => import('../../screens/DateNight/screens/View'));
const DateNightCreateScreen = lazy(() => import('../../screens/DateNight/screens/Create'));
const DateNightEditScreen = lazy(() => import('../../screens/DateNight/screens/Edit'));

const dateNightRoutes = [
    <Route
        exact
        key={routes.DATE_NIGHT_LIST}
        path={routes.DATE_NIGHT_LIST}
        render={() => (
            <Authenticated redirectTo={routes.HOME}>
                <DateNightListScreen />
            </Authenticated>
        )}
    />,

    <Route
        exact
        key={routes.DATE_NIGHT_VIEW}
        path={routes.DATE_NIGHT_VIEW}
        render={() => (
            <Authenticated redirectTo={routes.HOME}>
                <DateNightViewScreen />
            </Authenticated>
        )}
    />,

    <Route
        exact
        key={routes.DATE_NIGHT_CREATE}
        path={routes.DATE_NIGHT_CREATE}
        render={() => (
            <Authenticated redirectTo={routes.HOME}>
                <DateNightCreateScreen />
            </Authenticated>
        )}
    />,

    <Route
        exact
        key={routes.DATE_NIGHT_EDIT}
        path={routes.DATE_NIGHT_EDIT}
        render={() => (
            <Authenticated redirectTo={routes.HOME}>
                <DateNightEditScreen />
            </Authenticated>
        )}
    />,
];

export default dateNightRoutes;
